import { Component } from 'react';
import h from 'react-hyperscript';

class SecurityyPolicy extends Component {
  componentDidMount() {
    setTimeout(() => window.scrollTo(0, 0), 0);
  }
  render() {
    return h('.legal-wrapper', [h('h1', `Data and Data Security`), h('p', `< placeholder >`)]);
  }
}

export default SecurityyPolicy;



// WEBPACK FOOTER //
// ./src/components/SecurityPolicy/SecurityPolicy.js